@if (model()) {
  <header class="bg-secondary-light rounded-top-3 px-4 py-3 d-flex align-content-center" style="min-height: 64px">
    <div class="row justify-content-lg-between align-items-center flex-grow-1">
      <div class="col col-lg-auto flex-shrink-1 minw-0">
        <div
          id="mweModalTitle"
          class="h6 mb-0 text-white text-truncate text-center"
          data-test="modal-header-title"
          [translate]="model().titleKey"
        ></div>
      </div>
      <ng-content select="[slot='header-col']" />
      @if (model().dismissable) {
        <div class="col-auto">
          <mwe-button
            color="white"
            category="tertiary"
            size="sm"
            [isIconBtn]="true"
            buttonId="modal-header-close"
            (clicked)="cancel()"
            [title]="'shared.wizard.header.cancelAria' | translate: { name: model().titleKey | translate }"
          >
            <i class="far fa-times" aria-hidden="true"></i>
          </mwe-button>
        </div>
      }
    </div>
  </header>

  <div class="rounded-bottom-3 overflow-hidden" data-test="modal-content">
    <div class="bg-white p-4">
      <ng-content />
    </div>

    <ng-content select="[slot='footer']" />
  </div>
}
